import "@andypf/json-viewer";

import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  Inject,
  ViewChild,
  ViewEncapsulation,
  signal,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogTitle } from "@angular/material/dialog";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";

@Component({
  selector: "lib-ai-agent-debug-event-detail",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [MatDialogTitle, MatDialogContent, MatDialogClose, MatIconButton, MatIcon, CdkDrag, CdkDragHandle],
  template: `
    <div
      mat-dialog-title
      cdkDrag
      cdkDragHandle
      cdkDragRootElement=".cdk-overlay-pane"
      class="detail-title d-flex align-items-center gap-2 py-1 ps-3 pe-2 m-0"
    >
      <mat-icon class="detail-drag-icon flex-shrink-0">drag_indicator</mat-icon>
      <span>Event Detail</span>
      <span class="flex-grow-1"></span>
      <button matIconButton mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content>
      <andypf-json-viewer
        #viewer
        theme="material-lighter"
        indent="2"
        expanded="3"
        show-toolbar="true"
        show-size="true"
        class="detail-json-viewer"
      >
      </andypf-json-viewer>
    </mat-dialog-content>
  `,
  styles: [
    `
      /* Layout (d-flex, gap, padding, margin) is in the template via Bootstrap */
      .detail-title {
        cursor: move;
        user-select: none;
      }
      .detail-drag-icon {
        opacity: 0.4;
      }

      .detail-json-viewer {
        display: block;
        --base00: var(--mat-sys-surface-container-low, #f8f9fa);
        --base05: var(--mat-sys-on-surface, #1c1b1f);
        --base0D: var(--mat-sys-primary, #6750a4);
      }
    `,
  ],
})
export class AgentDebugEventDetailComponent implements AfterViewInit {
  @ViewChild("viewer") private viewerRef!: ElementRef;

  private readonly _data = signal<unknown>(null);

  constructor(@Inject(MAT_DIALOG_DATA) initial: unknown) {
    this._data.set(initial);
  }

  ngAfterViewInit(): void {
    this.updateViewer();
  }

  setData(data: unknown): void {
    this._data.set(data);
    this.updateViewer();
  }

  private updateViewer(): void {
    if (this.viewerRef?.nativeElement) {
      (this.viewerRef.nativeElement as any).data = this._data();
    }
  }
}
